<!-- <app-new-navbar *ngIf="!isOpenFromPopup"></app-new-navbar> -->

<div
  class="content"
  [ngClass]="{
    'profile-popup-content': isOpenFromPopup,
    'content-with-navbar': !isOpenFromPopup,
  }"
>
  <div class="form-cont">
    <div class="row">
      <div class="col-md-5 col-lg-4 col-xl-3" *ngIf="!isOpenFromPopup">
        <app-stickybar></app-stickybar>
      </div>

      <div
        [ngClass]="{
          'col-md-7 col-lg-8 col-xl-9': !isOpenFromPopup,
          'col-md-12 col-lg-12 col-xl-12': isOpenFromPopup,
        }"
      >
        <div
          class="card patient-details-card"
          [ngClass]="{
            'profile-details-card': isOpenFromPopup,
          }"
        >
          <div class="card-body">
            <form
              [formGroup]="userProfileForm"
              (ngSubmit)="onSubmit()"
              autocomplete="submit"
            >
              <div class="row">
                <div
                  class="profile-setting-header"
                  [ngClass]="{
                    'profile-setting-content': isOpenFromPopup,
                  }"
                >
                  <div class="hearder-setting">
                    <h1 *ngIf="!isOpenFromPopup">Profile Settings</h1>
                    <h2 *ngIf="isOpenFromPopup">Profile Settings</h2>
                    <!-- <div class="active-pack" *ngIf="!isOpenFromPopup">
                      <h5 class="smart-pack">
                        Smart Pack Eligibility:
                        <span
                          class="eligible"
                          [ngClass]="{
                            'eligible-true': eligibilityStatus === 'ELIGIBLE',
                            'eligible-false':
                              eligibilityStatus === 'INELIGIBLE',
                            'eligible-inactive':
                              eligibilityStatus === 'INACTIVE',
                          }"
                        >
                          {{
                            eligibilityStatus === "ELIGIBLE"
                              ? "Eligible"
                              : eligibilityStatus === "INELIGIBLE"
                                ? "Ineligible"
                                : "Inactive"
                          }}
                        </span>
                      </h5>
                      <p class="days-active">
                        Days Active: <strong>{{ activeDays }} Days</strong>
                      </p>
                    </div> -->
                  </div>
                  <div class="upload_file">
                    <div
                      class="photo-box"
                      [ngClass]="{
                        'profile-photo-box': isOpenFromPopup,
                      }"
                    >
                      <img
                        [src]="getProfileImage()"
                        (error)="onImgError($event)"
                        alt="Profile Image"
                      />
                    </div>
                    <div
                      class="flex-box"
                      [ngClass]="{
                        'profile-popup-content': isOpenFromPopup,
                      }"
                    >
                      <label for="file-upload" class="upload-btn button_class"
                        ><img
                          style="height: 20px; width: 20px"
                          src="../../../../assets/img/Profile_setting/Upload Image.png"
                          alt=""
                        />
                        Upload Photo</label
                      >
                      <input
                        type="file"
                        id="file-upload"
                        accept="image/png, image/jpeg, image/gif"
                        (change)="onImageSelect($event)"
                        autocomplete="image"
                      />
                      <p>Allowed JPG, JPEG, GIF or PNG. Max size of 2MB</p>
                    </div>
                  </div>
                </div>

                <ng-container *ngFor="let field of formFields">
                  <ng-container
                    *ngIf="
                      (field.name !== 'caregiver' &&
                        field.name !== 'alt_phone_number' &&
                        field.name !== 'phone') ||
                      (field.name === 'phone' &&
                        !(
                          isOpenFromPopup &&
                          (userProfile?.relationship_type === 'CHILD' ||
                            userProfile?.relationship_type === 'OFFLINE')
                        )) ||
                      (field.name === 'caregiver' && isOpenFromPopup) ||
                      (field.name === 'alt_phone_number' && !isOpenFromPopup)
                    "
                  >
                    <div class="col-12 col-md-6">
                      <div
                        class="mb-3"
                        [ngClass]="{ 'input-disabled': field?.isPhone }"
                      >
                        <label class="mb-2">
                          {{ field.label }}
                          <span
                            *ngIf="
                              field.label !== 'Landmark' &&
                              field.label !== 'Alternate Mobile Number'
                            "
                            class="text-danger"
                            >*</span
                          >
                        </label>

                        <ng-container [ngSwitch]="field.name">
                          <!-- Phone Input -->
                          <ngx-intl-tel-input
                            class="custom_imput"
                            *ngSwitchCase="'phone'"
                            [inputId]="'phone-input'"
                            [cssClass]="'custom'"
                            [preferredCountries]="preferredCountries"
                            [enableAutoCountrySelect]="false"
                            [enablePlaceholder]="false"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[
                              SearchCountryField.Iso2,
                              SearchCountryField.Name,
                            ]"
                            [customPlaceholder]="'Enter Phone Number'"
                            [selectFirstCountry]="true"
                            [selectedCountryISO]="CountryISO.Zimbabwe"
                            [separateDialCode]="true"
                            [maxLength]="10"
                            [phoneValidation]="false"
                            [ngClass]="{
                              none: shouldDisableField(field.name),
                            }"
                            (input)="onPhoneInput($event)"
                            name="phone"
                            [formControlName]="field.name"
                            autocomplete="new-phone"
                          >
                          </ngx-intl-tel-input>

                          <!-- DOB -->
                          <div class="position-relative" *ngSwitchCase="'dob'">
                            <input
                              #dp="bsDatepicker"
                              type="text"
                              class="form-control"
                              bsDatepicker
                              placement="top"
                              placeholder="Select Date of Birth"
                              (bsValueChange)="
                                handleDateOfBirthSelection($event)
                              "
                              [bsConfig]="bsDatepickerConfig"
                              [outsideClick]="true"
                              inputmode="none"
                              readonly
                              onkeydown="return false;"
                              [bsValue]="dobValue"
                              [disabled]="isDobDisabled"
                              autocomplete="new-dob"
                            />
                            <i
                              class="fa-regular fa-calendar position-absolute"
                              (click)="!isDobDisabled && dp.toggle()"
                              [class.disabled-icon]="isDobDisabled"
                            ></i>
                          </div>

                          <div
                            style="margin-top: 15px !important"
                            *ngIf="
                              field.name === 'phone' &&
                              userProfileForm.get('phone')?.touched &&
                              userProfileForm.get('phone')?.errors
                            "
                            class="text-danger mt-1"
                          >
                            {{
                              userProfileForm.get("phone")?.errors?.required
                                ? field.label + " is required."
                                : userProfileForm.get("phone")?.errors
                                      ?.invalidZimbabweMobile
                                  ? "Enter a valid mobile number"
                                  : ""
                            }}
                          </div>

                          <div
                            style="margin-top: 15px !important"
                            *ngIf="
                              userProfileForm.get('phone')?.errors?.[
                                'allZeros'
                              ] && userProfileForm.get('phone')?.touched
                            "
                            class="text-danger mt-1"
                          >
                            Phone number cannot be all zeros.
                          </div>

                          <!-- Gender -->
                          <select
                            [attr.disabled]="
                              shouldDisableField(field.name) ? true : null
                            "
                            *ngSwitchCase="'gender'"
                            class="form-select form-control"
                            [formControlName]="field.name"
                            autocomplete="new-gender"
                          >
                            <option value="" disabled>Select Gender</option>
                            <option
                              *ngFor="let bg of ['Male', 'Female', 'Other']"
                              [value]="bg"
                            >
                              {{ bg }}
                            </option>
                          </select>

                          <!-- Blood Group -->
                          <select
                            [attr.disabled]="
                              shouldDisableField(field.name) ? true : null
                            "
                            *ngSwitchCase="'blood_group'"
                            class="form-select form-control"
                            [formControlName]="field.name"
                            autocomplete="new-blood"
                          >
                            <option value="" disabled>
                              Select Blood Group
                            </option>
                            <option
                              *ngFor="
                                let bg of [
                                  'A+',
                                  'A-',
                                  'B+',
                                  'B-',
                                  'O+',
                                  'O-',
                                  'AB+',
                                  'AB-',
                                ]
                              "
                              [value]="bg"
                            >
                              {{ bg }}
                            </option>
                          </select>

                          <!-- Country -->
                          <select
                            *ngSwitchCase="'country'"
                            class="form-select form-control"
                            [formControlName]="field.name"
                            (change)="onCountryChange($event)"
                            autocomplete="new-country"
                          >
                            <option value="" disabled>Select Country</option>
                            <option
                              *ngFor="let c of countryDetails"
                              [value]="c.country_id"
                            >
                              {{ c.country_name }}
                            </option>
                          </select>

                          <!-- State -->
                          <select
                            *ngSwitchCase="'state'"
                            class="form-select form-control"
                            [formControlName]="field.name"
                            (change)="onStateChange($event)"
                            autocomplete="new-state"
                          >
                            <option value="" disabled>Select State</option>
                            <option
                              *ngFor="let s of selectedCountryStates"
                              [value]="s.state_id"
                            >
                              {{ s.state_name }}
                            </option>
                          </select>

                          <!-- City -->
                          <select
                            *ngSwitchCase="'city'"
                            class="form-select form-control"
                            [formControlName]="field.name"
                            autocomplete="new-city"
                          >
                            <option value="" disabled>Select City</option>
                            <option
                              *ngFor="let city of selectedStateCities"
                              [value]="city.city_name"
                            >
                              {{ city.city_name }}
                            </option>
                          </select>

                          <input
                            [placeholder]="field.placeholder"
                            [attr.maxlength]="
                              field.name === 'alt_phone_number' ||
                              field.name === 'dob'
                                ? field.maxLength
                                : null
                            "
                            [attr.minlength]="
                              field.name === 'dob' ? field.minLength : null
                            "
                            *ngSwitchDefault
                            [type]="field.type || 'text'"
                            class="form-control"
                            [formControlName]="field.name"
                            [attr.disabled]="
                              shouldDisableField(field.name) ? true : null
                            "
                            (keypress)="onlyAllowNumbers($event, field.name)"
                            (input)="
                              field.name === 'height' || field.name === 'weight'
                                ? sanitizeInput($event, field.name)
                                : null
                            "
                            autocomplete="field.name"
                          />

                          <!-- Caregiver -->
                          <div
                            *ngSwitchCase="'caregiver'"
                            class="assign-caregiver"
                          >
                            <div
                              *ngIf="!assignedCareGiver"
                              class="select-caregiver"
                              (click)="openAssignCaregiverModal()"
                            >
                              Select Caregiver
                            </div>
                            <div
                              *ngIf="assignedCareGiver"
                              class="caregiver-content"
                            >
                              <!-- Left Section -->
                              <div>
                                <div class="caregiver-name">
                                  {{ assignedCareGiver?.first_name }}
                                  {{ assignedCareGiver?.last_name }}
                                </div>

                                <div class="caregiver-phone">
                                  {{ assignedCareGiver?.country_dial_code }}-
                                  {{
                                    assignedCareGiver?.phone_number ||
                                      assignedCareGiver?.phone
                                  }}
                                </div>
                              </div>

                              <div class="caregiver-right">
                                <span class="caregiver-meta">
                                  ({{ assignedCareGiver?.age ?? "-" }}/
                                  {{
                                    assignedCareGiver?.gender === "Male"
                                      ? "M"
                                      : assignedCareGiver?.gender === "Female"
                                        ? "F"
                                        : "-"
                                  }})
                                </span>

                                <span
                                  class="caregiver-action"
                                  (click)="openAssignCaregiverModal()"
                                >
                                  Edit
                                </span>

                                <span class="divider">/</span>

                                <span class="caregiver-action remove">
                                  Remove
                                </span>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <div
                          class="text-danger mt-1"
                          *ngIf="
                            userProfileForm.get(field.name)?.touched &&
                            userProfileForm.get(field.name)?.invalid
                          "
                        >
                          <ng-container
                            *ngIf="field.name === 'dob'; else defaultError"
                          >
                            <div
                              class="text-danger mt-1"
                              *ngIf="
                                userProfileForm.get('dob')?.errors?.required
                              "
                            >
                              Date of Birth is required.
                            </div>
                            <div
                              class="text-danger mt-1"
                              *ngIf="
                                userProfileForm.get('dob')?.errors?.futureDate
                              "
                            >
                              Date of Birth cannot be in the future
                            </div>
                          </ng-container>
                          <ng-template #defaultError>
                            <ng-container
                              *ngIf="field.name === 'alt_phone_number'"
                            >
                              <div
                                class="text-danger mt-1"
                                *ngIf="
                                  userProfileForm.get('alt_phone_number')
                                    ?.errors?.['allZeros']
                                "
                              >
                                Phone number cannot be all zeros.
                              </div>

                              <div
                                class="text-danger mt-1"
                                *ngIf="
                                  !userProfileForm.get('alt_phone_number')
                                    ?.errors?.['allZeros'] &&
                                  userProfileForm.get('alt_phone_number')
                                    ?.errors?.invalidZimbabweMobile
                                "
                              >
                                Enter a valid alternate mobile number!
                              </div>
                            </ng-container>
                            <ng-container *ngIf="field.name === 'email'">
                              <div
                                *ngIf="
                                  userProfileForm.controls.email.touched ||
                                  userProfileForm.controls.email.dirty
                                "
                              >
                                <div
                                  class="text-danger mt-1"
                                  *ngIf="
                                    userProfileForm.controls.email.errors
                                      ?.required
                                  "
                                >
                                  Email is required.
                                </div>
                                <div
                                  class="text-danger"
                                  *ngIf="
                                    userProfileForm.controls.email.errors
                                      ?.emailInvalid
                                  "
                                >
                                  Please enter a valid email address.
                                </div>

                                <div
                                  class="text-danger"
                                  *ngIf="
                                    userProfileForm.controls.email.errors
                                      ?.emailTooLong
                                  "
                                >
                                  Email must not exceed 64 characters.
                                </div>
                              </div>
                            </ng-container>
                            <ng-container
                              *ngIf="
                                field.name === 'height' ||
                                field.name === 'weight'
                              "
                            >
                              <div
                                class="text-danger mt-1"
                                *ngIf="
                                  userProfileForm.get(field.name)?.errors
                                    ?.required
                                "
                              >
                                {{ field.label }} is required.
                              </div>

                              <div
                                class="text-danger mt-1"
                                *ngIf="
                                  userProfileForm.get(field.name)?.errors
                                    ?.invalidZero
                                "
                              >
                                {{ field.label }} must be greater than 0.
                              </div>

                              <div
                                class="text-danger mt-1"
                                *ngIf="
                                  userProfileForm.get(field.name)?.errors
                                    ?.invalidNumber
                                "
                              >
                                Enter a valid number.
                              </div>
                            </ng-container>

                            <ng-container
                              *ngIf="
                                field.name !== 'phone' &&
                                field.name !== 'email' &&
                                field.name !== 'dob' &&
                                field.name !== 'alt_phone_number' &&
                                field.name !== 'height' &&
                                field.name !== 'weight'
                              "
                            >
                              {{ field.label }} is required.
                            </ng-container>
                          </ng-template>
                        </div>
                      </div>

                      <div
                        *ngIf="
                          field.name === 'last_name' &&
                          userProfileForm.errors?.nameLengthExceeded &&
                          (userProfileForm.get('first_name')?.touched ||
                            userProfileForm.get('last_name')?.touched)
                        "
                        class="text-danger mt-1"
                      >
                        First and Last name should not exceed 35 characters.
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>

              <div class="submit-section">
                <button type="submit" class="btn submit-btn button_class">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-new-footer *ngIf="!isOpenFromPopup"></app-new-footer> -->

<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="skyblue"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p class="spinner-text">Please wait...</p>
</ngx-spinner>
